import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Progress } from 'reactstrap';

import { useTest, useUnit } from 'hooks/units/index';
import {
  BAR_COLORS,
  DEFAULT_DURATION,
  DEFAULT_REMAINDER,
} from 'constants/constants';
import { getThemeColor } from 'store/settings';
import { useSelector } from 'react-redux';
import { timeExpired } from 'modules/Course/CourseDetail/optimizedDetailPage/lesson-access-modal';
import { useRouter } from 'next/router';
import { IoAlarmSharp } from 'react-icons/io5';

const Duration = ({
  onSubmitTest,
  startTime,
  seconds,
  hasSubmittedRef,
  durationDisable,
  setDurationDisable,
}) => {
  const {
    query: { unitId, lessonType },
  } = useRouter();
  const unitSelected = useUnit();

  const durationDisplay =
    typeof unitSelected?.config?.durationDisplay == 'boolean'
      ? unitSelected?.config?.durationDisplay
      : true;

  const reminderTime =
    unitSelected?.config?.alertDuration &&
    unitSelected?.config?.duration > unitSelected?.config?.alertDuration
      ? Number(unitSelected?.config?.alertDuration)
      : DEFAULT_REMAINDER;
  const test = useTest();
  const duration = seconds ? seconds * 60 : unitSelected?.config?.duration * 60;
  const [isDurationEnd, setIsDurationEnd] = useState(false);
  const themeStatus = useSelector(getThemeColor);
  const [timerContent, setTimerContent] = useState(undefined);

  useEffect(() => {
    const durationNow =
      new Date(unitSelected?.testStartTime).getTime() +
      duration * 1000 -
      Date.now();

    let timer = durationNow / 1000;

    const display = durationDisplay && document.querySelector('#timer');
    const bar = durationDisplay && document.querySelector('#progressBar');

    const startTimer = setInterval(() => {
      const minutes = parseInt(timer / 60, 10);
      const seconds = parseInt(timer % 60, 10);

      const remainingSeconds = minutes * 60 + seconds;
      const percentage = (remainingSeconds * 100) / duration;

      let sortedKeys = Object.keys(BAR_COLORS).sort((a, b) => b - a);

      function setBarColor(a) {
        for (let key of sortedKeys) {
          if (a > Number(key)) {
            return BAR_COLORS[key];
          }
        }
      }

      let currentTime = `${minutes < 10 ? `0${minutes}` : minutes}.${
        seconds < 10 ? `0${seconds}` : seconds
      }`;

      if (durationDisplay) {
        display.textContent = currentTime;
      }

      let number = reminderTime;

      //let barColor = '#43a047';

      if (durationDisplay) {
        let barColor = display.textContent <= number ? '#e53d35' : '#43a047';

        // barColor = setBarColor(percentage);

        const barChildren = [...bar.children][0];
        barChildren.style.width = `${percentage}%`;
        barChildren.style.backgroundColor = barColor;
      }

      setTimerContent(currentTime);

      if (isDurationEnd) {
        return null;
      }
      if (Math.floor(timer) <= 0 && !isDurationEnd) {
        setIsDurationEnd(true);
        localStorage.setItem('unitId', unitId);
        localStorage.setItem('testStartTime', unitSelected?.testStartTime);
        if (unitSelected?.config?.duration && !hasSubmittedRef.current) {
          hasSubmittedRef.current = true;
          let message = unitSelected?.config?.duration
            ? 'The quiz duration has ended '
            : "Time's up!";

          // timeExpired(
          //   'You can only modify the current question.',
          //   {
          //     confirmButtonColor: themeStatus,
          //   },
          //   message,
          // );

          setDurationDisable(true);

          onSubmitTest({
            autoSubmit: true,
            isSubmit: false,
          });
        }
      } else if (!isDurationEnd) {
        --timer;
      }
    }, 1000);

    return () => {
      clearInterval(startTimer);
      localStorage.setItem('unitId', unitId);
      localStorage.setItem('testStartTime', unitSelected?.testStartTime);
    };
  }, [duration, onSubmitTest, startTime]);

  return (
    <div className="">
      <section
        className={`d-flex ${
          durationDisplay ? 'justify-content-between' : 'justify-content-end'
        }`}
      >
        {durationDisplay && (
          <p id="timer">
            {seconds && seconds !== DEFAULT_DURATION
              ? seconds
              : unitSelected?.config?.duration}
            :00
          </p>
        )}
        {!durationDisable && timerContent <= reminderTime && (
          <div className="d-flex justify-content-end align-items-start col-6 col-md-6 col-sm-6">
            <p
              style={{
                backgroundColor: 'rgba(196, 22, 28, .12)',
                fontWeight: 'bold',
                color: '#c4161c',
                padding: 5,
              }}
            >
              <span style={{ marginRight: 3 }}>
                <IoAlarmSharp size={25} />
              </span>
              {`${reminderTime} minutes remaining`}
            </p>
          </div>
        )}
      </section>
      {durationDisplay && duration && <Progress id="progressBar" />}
    </div>
  );
};

Duration.propTypes = {
  onSubmitTest: PropTypes.func.isRequired,
};

export default Duration;
